import * as lexLoginActionType from '../actionsType/lexLogin.actionType';

export const initialState = {
    status: ''
};

export function lexLoginReducer(state = initialState, action) {
    switch (action.type) {
        case lexLoginActionType.LOGIN_USER:
            return {...state, status: lexLoginActionType.LOGIN_USER};
        case lexLoginActionType.LOGIN_SUCCESS:
            return {...state, status: lexLoginActionType.LOGIN_SUCCESS};
        case lexLoginActionType.LOGIN_MID:
            return {...state, status: lexLoginActionType.LOGIN_MID};
        case lexLoginActionType.TERMS:
            return {...state, status: lexLoginActionType.TERMS};
        case lexLoginActionType.LOGOUT:
            return {...state, status: lexLoginActionType.LOGOUT};
        case lexLoginActionType.LOGIN_ERROR:
            return {...state, status: lexLoginActionType.LOGIN_ERROR};
        default:
            return state;
    }
}
